import { defineMessages } from "@/i18n";
import en from "./en";

export const framesGithubMessages = defineMessages("frames-github", en);
